import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaTrashAlt, FaUpload } from "react-icons/fa";
import { Toast } from "primereact/toast";
import { Panel } from "primereact/panel";
import { BiDetail } from "react-icons/bi";
import { PacmanLoader } from "react-spinners";

const FileButton = styled.button`
  background: #005559;
  color: #fff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 5px;
  &:hover {
    background: #011617;
  }
`;

const FileCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
`;

const Placeholder = styled.h6`
  color: #aaa;
  text-align: center;
`;

const FileDetails = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const RemoveButton = styled(FileButton)`
  background: #d03030;
  &:hover {
    background: #a30000;
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100%;
`;

function FileUpload({
  handleFile,
  onRemoveFile,
  isRemoveFile,
  showImageBase64,
  loadedImage,
}) {
  const toastBC = React.useRef(null);
  const upload = React.useRef(null);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const removeFile = () => {
    setFile(null);
    setPreview(null);
    handleFile(null);
    upload.current.value = "";
  };

  useEffect(() => {
    if (loadedImage) {
      setFile(loadedImage);
      setPreview(loadedImage);
      handleFile(loadedImage);
    }
  }, [loadedImage]); // eslint-disable-line

  const header = () => {
    return (
      <>
        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          ref={upload}
          onChange={(e) => {
            onFileChange(e);
          }}
        />
        <FileButton
          onClick={(e) => {
            e.preventDefault();
            upload.current.click();
          }}
        >
          <FaUpload />
          Choose Image
        </FileButton>
        &nbsp;
      </>
    );
  };

  const onFileChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = function (evt) {
        const base64 = evt.target.result;
        setFile(selectedFile);
        setPreview(base64);
        setLoading(false);
        handleFile(selectedFile, base64);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  useEffect(() => {
    if (isRemoveFile) {
      removeFile();
      onRemoveFile();
    }
  }, [isRemoveFile]); // eslint-disable-line

  return (
    <Panel header={header}>
      <Toast ref={toastBC} position="bottom-center" />

      <div className="image-flex ">
        {file ? (
          <FileCard key={file.name}>
            {
              <img
                src={preview}
                alt={file.name}
                style={{ maxWidth: "100px", maxHeight: "100px" }}
              />
            }
            <FileDetails>
              <BiDetail color="orange" />
              {"Size: " + (file.size / (1024 * 1024)).toFixed(2) + " MB"}
            </FileDetails>
            <RemoveButton onClick={removeFile}>
              <FaTrashAlt />
            </RemoveButton>
          </FileCard>
        ) : (
          <Placeholder>
            {loading ? (
              <LoaderContainer>
                <PacmanLoader color={"#02777c"} size={25} />
              </LoaderContainer>
            ) : (
              "No image selected"
            )}
          </Placeholder>
        )}
      </div>
    </Panel>
  );
}

export default FileUpload;
